import String from "lodash/string";

export default {

  all: [
    'specificCoolingCapacity::nullable:true',
    'oil',
    'calculation-style',
    'oilInletTemperature',
    'airInletTemperature',
    'aboveSeaLevel',
    'oilFlowRate',
  ],

  alreadyKnown: [
    'coolingPower',
  ],

  pumpData: [
    'oilPressure',
    'pumpType',
  ],

  heatingUpTime: [
    'tankCapacity',
    'startingTemperature',
    'endTemperature',
    'heatingTime'
  ],

  get(category, name) {
    return this[category].find((item) => {
      return this.getLabel(item) === name
    })
  },

  getLabel(expr) {
    return String.split(expr, '::')[0]
  },

  getNullable(expr) {
    return String.split(expr, '::')[1]
  },

  isNullable(category, name) {
    return String.split(this.getNullable(this.get(category, name)), ':')[1] ?? false
  }
}
